import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const FinalCTASection = ({ id }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://server.fillout.com/embed/v1/";
    script.async = true;
    document.body.appendChild(script);
    return () => { if (document.body.contains(script)) document.body.removeChild(script); };
  }, []);

  return (
    <section id={id} className="py-24 bg-padua-ivory relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-80 bg-padua-olive hidden md:block opacity-90" />
      
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row bg-padua-cream rounded-2xl shadow-[0_35px_60px_-15px_rgba(0,0,0,0.15)] overflow-hidden border border-padua-gold/20">
          
          <div className="lg:w-5/12 bg-padua-olive p-12 md:p-16 text-padua-ivory flex flex-col justify-center relative">
            <div className="absolute inset-0 bg-tile-pattern opacity-10 pointer-events-none" />
            <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <h2 className="text-4xl md:text-5xl font-serif mb-8 leading-tight">Ready to Find Out if Padua Is the One?</h2>
              <p className="text-padua-ivory/90 text-lg mb-12 leading-relaxed font-light">
                Schedule a private tour and walk through the estate with our team. We look forward to meeting you.
              </p>
              
              <div className="space-y-8 mt-auto">
                <div className="flex items-center gap-5">
                  <div className="w-14 h-14 rounded-full bg-padua-ivory/10 flex items-center justify-center border border-padua-ivory/20 shadow-inner">
                    <SafeIcon name="MapPin" className="text-padua-gold w-6 h-6" />
                  </div>
                  <div>
                    <p className="font-bold text-[10px] uppercase tracking-[0.3em] text-padua-gold mb-1">Location</p>
                    <p className="font-serif text-2xl">Claremont, California</p>
                  </div>
                </div>
                
                <div className="pt-8 border-t border-padua-ivory/10">
                  <div className="flex items-center gap-2 text-padua-gold mb-2">
                    <SafeIcon name="Clock" className="w-4 h-4" />
                    <span className="text-[10px] uppercase tracking-widest font-bold">Expect a Response</span>
                  </div>
                  <p className="text-sm italic text-padua-ivory/70">
                    Our team typically responds within 24 hours.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="lg:w-7/12 bg-padua-cream">
            <div className="w-full min-h-[800px] md:min-h-[750px] p-2">
              <div
                style={{ width: '100%', height: '100%', minHeight: '750px' }}
                data-fillout-id="52UbEds248us"
                data-fillout-embed-type="standard"
                data-fillout-inherit-parameters
                data-fillout-dynamic-resize
              />
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;